import React from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import Dialpad from '../../Dialpad';
import { showCallDialog } from 'flow/actions/call-dialog-actions';

const CentralSwitchDialpadWrapper = () => {
    const dispatch = useAppDispatch();
    return <Dialpad onEnter={(number) => dispatch(showCallDialog(number))} />;
};

export default CentralSwitchDialpadWrapper;
